import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import retCode from '@/utils/retCode'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 6000000 // request timeout
  // withCredentials: true
  // headers: {
  //   'Content-Type': 'application/json;charset=utf-8'
  // }
})
var message = ''
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (!config.params) {
      config.params = {}
    }
    if (config.method === 'get') {
      delete config.headers['Content-Type']
    }
    config.params['_'] = Math.random()
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// service.interceptors.request.use(
//   config => {
//     console.log('请求数接口{' + config.url + '}数据为->', config)
//     return config
//   },
//   error => {
//     console.log(error) // for debug
//     return Promise.reject(error)
//   }
// )
// 当前数组包含的消息不报错提示
const noErrorMeaasge = ['证件号码已存在', '未查到您的职业资格证书信息', '请将姓名、身份证号、联系方式及身份证（正反面）、考试或认定取得的职业资格证书等证明扫描件发至zydj1@cnaec.org.cn邮箱，以便我们进行核实、处理！']

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.headers['web-version']) {
      if (+process.env.VUE_APP_VERSION_CODE < +response.headers['web-version']) {
        location.reload()
        return
      }
    }
    const res = response.data
    if (res.code !== retCode.RET_OK) {
      // 当前数组包含的消息不报错提示
      if (res.message !== message && noErrorMeaasge.includes(res.message) === false) {
        Message({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000,
          showClose: true,
          onClose: function() {
            message = ''
          }
        })
        message = res.message
      }

      if (res.code === retCode.RET_NOT_LOGIN) {
        // to re-login
        store.commit('user/RESET_STATE')
        store.dispatch('router/resetRouter')
        location.reload()
        return
      }
      if (res.code === retCode.TO_LOGIN) {
        store.dispatch('user/logout')
        return Promise.reject(res.message)
      }

      return Promise.reject(res)
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
      showClose: true
    })
    return Promise.reject(error)
  }
)

export default service
